import React from "react";

const TitleLayout = ({
    buttonType
}) => {
    const getTitle = (buttonType) => {
        if (buttonType.includes("Raw")) {
            return "RAW DATA";
        } else if (buttonType.includes("Summary-Among-Collections")) {
            return "SPECIES SUMMARY AMONG COLLECTION SITES";
        } else if (buttonType.includes("Weekly")) {
            return "WEEKLY SPECIES REPORT";
        } else if (buttonType.includes("Pie")) {
            return "SPECIES SUMMARY";
        } else if (buttonType.includes("Bar")) {
            return "SPECIES SUMMARY AMONG COLLECTION SITES";
        } else if (buttonType.includes("Line")) {
            return "SPECIES ABUNDANCE BY MONTH";
        }
        return "REPORTS";
    };

    const title = getTitle(buttonType);

    return (

        <div
            style={{
                flex: 1,
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "500",
                marginRight: "160px",
            }}
        >
            {title}
        </div>

    )
}
export default TitleLayout;